import { DataTable } from "@/components/data-table";
import { Form } from "@/components/form";
import { formatNumber, formatString } from "@/shared/formats";
import { Stack, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import PrecioView from "@/features/monetizacion/components/precio-view";
import { DetalleDE } from "./de-articulo-search";
import { getDescripcionUnidadMedida } from "../../utils/unidades-medida";

interface DEArticuloListProps {
    items: DetalleDE[],
    remove?: (index: number) => void,
    disabled?: boolean,
    forAutoFactura?: boolean,
    hidePrecio?: boolean,
}

export default function DEArticuloList({
    items,
    remove = () => { },
    disabled = false,
    forAutoFactura = false,
    hidePrecio = false,
}: DEArticuloListProps) {
    const { monedaBase } = useMonetizacion();
    const displayItems = [...items].reverse();

    return <Stack gap={1} flex={1} minHeight={"350px"}>
        <Stack direction={"row"} alignItems={"center"}>
            <Typography variant="h6" flex={"1 1 auto"}>Ítems</Typography>
        </Stack>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={displayItems}
                columns={[
                    { header: "#", render: (_, index) => formatNumber(items.length - index), width: "auto" },
                    { header: "Código", render: row => formatString(row.codigo), width: "100px" },
                    { header: "Descripción", render: row => formatString(row.descripcion) },
                    !hidePrecio && { header: `Precio (${monedaBase.simbolo})`, render: row => formatNumber(row.precio), align: "right" },
                    !forAutoFactura && !hidePrecio && { header: "IVA", render: row => row.iva === "exenta" ? "Exenta" : `${row.iva}%`, align: "right" },
                    { header: "Cantidad", render: row => `${formatNumber(row.cantidad)} ${getDescripcionUnidadMedida(row.unidadMedida)}`, align: "right" },
                    !hidePrecio && { header: `Subtotal (${monedaBase.simbolo})`, render: row => formatNumber(row.cantidad * row.precio), align: "right" },
                    {
                        header: "", render: (_, index) => <Form.IconButton size="small" onClick={() => remove(items.length - 1 - index)} disabled={disabled}>
                            <ClearIcon fontSize="small" />
                        </Form.IconButton>, width: "auto", align: "center"
                    }
                ]}
                footers={hidePrecio ? [] : [
                    { render: () => <Typography variant="subtitle1">Total</Typography>, span: forAutoFactura ? 3 : 4 },
                    { render: () => <></> },
                    { render: () => <Typography variant="subtitle2">{formatNumber(items.reduce((p, v) => p + v.cantidad, 0))}</Typography>, align: "right", span: 1 },
                    { render: () => <PrecioView variant="subtitle2" monto={items.reduce((p, v) => p + v.precio * v.cantidad, 0)} />, align: "right" },
                    { render: () => <></> },
                ]}
            />
        </DataTable>
    </Stack>
}
